import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'

export interface ModalBibliographySearchConditionStoreInterface {
  isBack?: boolean
  isTooliSearch?: boolean
  isSearchTargetDisabled?: boolean
  onSearch?: () => void
  onSearchAuthority?: () => void
  onSearchContent?: () => void
  onCancel?: () => void
}

@Module({
  name: 'ModalBibliographySearchConditionStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalBibliographySearchConditionStore extends BaseStore {
  _isOpen: boolean = false

  _isBack: boolean = false

  _isTooliSearch: boolean = false

  _isSearchTargetDisabled: boolean = true

  _searchCallback?: () => void

  _searchAuthorityCallback?: () => void

  _searchContentCallback?: () => void

  get isOpen(): boolean {
    return this._isOpen
  }

  get isBack(): boolean {
    return this._isBack
  }

  get isTooliSearch(): boolean {
    return this._isTooliSearch
  }

  get isSearchTargetDisabled(): boolean {
    return this._isSearchTargetDisabled
  }

  @Mutation
  public open(params?: ModalBibliographySearchConditionStoreInterface) {
    this._isOpen = true
    this._isBack = !!params?.isBack
    this._isTooliSearch = !!params?.isTooliSearch
    this._isSearchTargetDisabled = params?.isSearchTargetDisabled ?? true
    this._searchCallback = params?.onSearch
    this._searchAuthorityCallback = params?.onSearchAuthority
    this._searchContentCallback = params?.onSearchContent
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public searchComplete() {
    if (this._searchCallback) {
      this._searchCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public searchAuthorityComplete() {
    if (this._searchAuthorityCallback) {
      this._searchAuthorityCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public searchContentComplete() {
    if (this._searchContentCallback) {
      this._searchContentCallback()
    }

    this._isOpen = false
  }
}
